import React from 'react';
import {
  SiReddit, SiFacebook, SiTelegram, SiInstagram, SiX, SiWhatsapp,
  SiDiscord, SiQuora, SiTiktok, SiYoutube, SiNextdoor, SiGoogle,
} from 'react-icons/si';
import { FaLinkedin } from 'react-icons/fa6';
import { TagIcon } from '@heroicons/react/24/solid';

type IconCmp = React.ComponentType<{ className?: string; style?: React.CSSProperties }>;

// Brand mark + brand colour per connector (logos via Simple Icons / Font Awesome).
const MAP: Record<string, { Icon: IconCmp; color: string }> = {
  reddit:          { Icon: SiReddit,    color: '#FF4500' },
  facebook:        { Icon: SiFacebook,  color: '#1877F2' },
  telegram:        { Icon: SiTelegram,  color: '#26A5E4' },
  instagram:       { Icon: SiInstagram, color: '#E4405F' },
  twitter:         { Icon: SiX,         color: '#000000' },
  linkedin:        { Icon: FaLinkedin,  color: '#0A66C2' },
  whatsapp:        { Icon: SiWhatsapp,  color: '#25D366' },
  discord:         { Icon: SiDiscord,   color: '#5865F2' },
  quora:           { Icon: SiQuora,     color: '#B92B27' },
  tiktok:          { Icon: SiTiktok,    color: '#111111' },
  youtube:         { Icon: SiYoutube,   color: '#FF0000' },
  nextdoor:        { Icon: SiNextdoor,  color: '#00B246' },
  google_business: { Icon: SiGoogle,    color: '#4285F4' },
};

export function ChannelIcon({
  id, className = 'w-5 h-5', colored = true,
}: { id: string; className?: string; colored?: boolean }) {
  const entry = MAP[id];
  if (!entry) return <TagIcon className={className} />;   // e.g. classifieds (Dubizzle)
  const { Icon, color } = entry;
  return <Icon className={className} style={colored ? { color } : undefined} />;
}
